import React from "react";
import { Dialog } from "primereact/dialog";
import { useChatBotStore } from "../../store/ChatBotStore";
import { useAppContext } from "../../AppContext";
import ChatBotSidebar from "./ChatBotSidebar";
import ChatBotMain from "./ChatBotMain";
import PdfViewer from "../global/PdfViewer";
import "./ChatBot.scss";

const ChatBot = () => {
  const { isChatOpen, closeChat, sidebarOpen, pdfToDisplay, pdfContainerRef } =
    useChatBotStore();
  const { user: [user], selectedCompany: [selectedCompany] } = useAppContext();

  if (!user || !selectedCompany) return null;

  return (
    <>
      <Dialog
        visible={isChatOpen}
        onHide={closeChat}
        className="chatbot-dialog"
        header={null}
        footer={null}
        closable={false}
        draggable
        resizable
        modal
        blockScroll
      >
        <div
          className={`chatbot-container ${
            sidebarOpen ? "sidebar-open" : "sidebar-collapsed"
          }`}
        >
          <ChatBotSidebar />
          <ChatBotMain />
        </div>
      </Dialog>
      <div className="pdf-container" ref={pdfContainerRef}>
        <PdfViewer pdfToDisplay={pdfToDisplay} pdfContainer={pdfContainerRef} />
      </div>
    </>
  );
};

export default ChatBot;
